import axios, { AxiosRequestConfig } from 'axios';
import CommonUtils from './CommonUtils';
import Constants from '../constants/Index';
import { ElMessage } from "element-plus";
//默认 Content-Type: application/json，如果需要处理，可以在这里进行配置
//axios.defaults.headers
console.log(import.meta.env.BASE_URL)
console.log(import.meta.env.VITE_IS_DEV)
//创建实例
const axiosInstance = axios.create({
  //同意前缀，方便生产环境nginx转发到
  //baseURL: import.meta.env.VITE_IS_DEV == "yes" ? 'http://172.17.97.142:8080/' :'/qzktapi',
  baseURL:import.meta.env.DEV?'/xuepaiapi/': 'https://xuepaiapi.ooowin.com/',
  //baseURL: 'http://172.17.97.142:8080/',
  //send cookies when cross-domain requests
  withCredentials: true,
  timeout: 15000,
});

//request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    //可以进行请求拦截处理，如添加请求头，token 等
    if (CommonUtils.getLocalStore(Constants.TokenKey)) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['token'] = CommonUtils.getLocalStore(Constants.TokenKey);
      config.headers['phone'] = CommonUtils.getLocalStore(Constants.PhoneKey);
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);
// response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const res = response.data;
    console.log(res)
    if(res.code==10003){
      ElMessage.error("登录超时");
      //清除localstore
      CommonUtils.clearLocalStore()
      setTimeout(()=>{
        window.location.href = "/";
      },500)
    }
    return Promise.resolve(res);
  },
  (error) => {
    console.log('err' + error);
    return Promise.reject(error);
  }
);

interface ResulutData {
  code: number;
  msg?: string;
  // eslint-disable-next-line
  data?: any;
}

interface RequstType {
  (url: string, params?: object, config?: AxiosRequestConfig): Promise<ResulutData>;
}

// 封装 get 方法，类型为Get
const get: RequstType = async (url) => {
  return await axiosInstance.get(url);
};

// 封装 get 方法，类型为Get
const post: RequstType = async (url, params) => {
  return await axiosInstance.post(url, params);
};

const HttpUtils = {
  get,
  post,
};

// 导出封装后的axios
export default HttpUtils;
